/**
 * Auth context object + hook — separate module from the provider component
 * so AuthContext.tsx only exports a component (react-refresh requirement).
 */
import { createContext, useContext } from 'react';

export interface AuthUser {
  email: string;
  name: string;
  tenant_uuid?: string;
  system_role?: string;
}

export interface LoginResult {
  success: boolean;
  error?: string;
  user?: AuthUser;
}

export interface AuthContextType {
  user: AuthUser | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<LoginResult>;
  logout: () => Promise<void>;
  getAccessToken: () => string | null;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = (): AuthContextType => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
